import React, { useEffect, useState } from 'react'
import { listCourses, mostSearchedCourses } from '../../Services/courseService';
import CourseTemplate from './CourseTemplate';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTranslation } from 'react-i18next';

const MostSearchedCourses = () => {
    
  const [courses, setCourses] = useState([]);
  const [backupCourses, setBackupCourses] = useState([]);

//const [showAllCourses, setShowAllCourses] = useState(false);
  const [loading, setLoading]=useState(true);
  const [error, setError]=useState(null);
  const { t } = useTranslation(); 

  const [message, setMessage]=useState();
 
  useEffect(() => {
        const fetchCourses = async () => {
          try {
            const response = await mostSearchedCourses();
            setCourses(Array.isArray(response?.data?.data) ? response?.data?.data : []);
            setMessage(response?.data?.message);

          } catch (error) {
            setError('Error fetching courses:', error);
          } finally{
            setLoading(false)
        }
        };
    
        fetchCourses();
      }, []);

      useEffect(() => { 
        const fetchCourses = async () => {
          setLoading(true);
          try {
            const response = await listCourses();
            const allCourses = Array.isArray(response?.data?.data) ? response?.data?.data : [];
            const sortedCourses = allCourses.sort((a, b) => 
              a.title.trim().toLowerCase().localeCompare(b.title.trim().toLowerCase())
            );
            setBackupCourses(sortedCourses.length > 0 ? [sortedCourses[0]] : []);
          } catch (error) {
            setError('Error fetching courses. Please try again later.');
          } finally {
            setLoading(false);
          }
        };
      
        fetchCourses();
      }, []);
      

      return (
        <div>
          {loading ? (
            <ClipLoader color="#333333" loading={loading} size={30} id="clipLoader" />
          ) : courses?.length > 0 ? (
            <CourseTemplate
              coursesData={courses}
              pageTitle={t("MostSearchedCourses")}
              error={error}
            />
          ) : backupCourses?.length > 0 ? (
            <CourseTemplate
              coursesData={backupCourses}
              pageTitle={t("MostSearchedCourses")}
              error={error}
            />
          ) : (
            <div className="ES-Empty-Container">
              <h2 className="ES-Heading">{message}</h2>
            </div>
          )}
        </div>
      );
      
}


export default MostSearchedCourses;











// import React, { useEffect, useState } from 'react';
// import { mostSearchedCourses } from '../../Services/courseService';
// import { useNavigate } from 'react-router-dom';
// import '../Courses/Courses.css';
// import { useTranslation } from 'react-i18next';
// import ClipLoader from 'react-spinners/ClipLoader';

// const MostSearchedCourses = () => {
//   const navigate = useNavigate();
//   const [courses, setCourses] = useState([]);
//   const [showAllCourses, setShowAllCourses] = useState(false);
//   const [loading, setLoading]=useState(true)

//   const {t}=useTranslation();

//   // useEffect(() => {
//   //   const token = localStorage.getItem('token');
//   //   if (!token) {
//   //     navigate('/');
//   //   }
//   // }, [navigate]);

  
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await mostSearchedCourses();
//         setCourses(Array.isArray(response.data) ? response.data : []);
//       } catch (error) {
//         console.error('Error fetching courses:', error);
//       } finally{
//         setLoading(false)
//     }
//     };

//     fetchCourses();
//   }, []);

//   const renderRating = (rating) => {
//     const fullStars = Math.floor(rating);
//     const halfStar = rating % 1 >= 0.5;
//     let stars = '★'.repeat(fullStars);
//     if (halfStar) stars += '☆';
//     return stars;
//   };

//   const handleCardClick = async (courseId) => {
//     navigate(`/coursedetails/${courseId}`);
//     localStorage.setItem('courseId', courseId);
//   };

//   return (
//     <div className="course-container">
//        {
//              loading ? ( <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' /> ):
//        (<>
//        <h1 className="course-header">{t("Most Searched Courses")} </h1>
//       <div className="course-grid">
//         {(showAllCourses ? courses : courses.slice(0, 4)).map(course => (
//           <div key={course.courseId} className="es-course-card " onClick={() => handleCardClick(course.courseId)}>
//             <img src={course.imageUrl} alt={course.title} className="course-image" />
//             <h2 className="course-title">{course.title}</h2>
//             <p className="course-description">{course.description}</p>
//             <p className="course-syllabus">{course.syllabus}</p>
//             <div className="course-rating">  {renderRating(course.rating || 4)}</div>
//             <div className="course-footer">
//               <p className="course-instructor">{course.createdBy}</p>
//               <p className="course-price">${course.price.toFixed(2)}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//       <div className="container">
//         <button className="explore-more-btn" onClick={() => setShowAllCourses(prev => !prev)}>
//         {showAllCourses ? t("ExploreLess") : t("ExploreMore") }
//         </button>
//       </div></>)
//        }
      
//     </div>
//   );
// }

// export default MostSearchedCourses;
